__turbopack_context__.v({
  "className": "VRElJW_className",
});
